export function tokenErrorDetail(response) {
  const data = response?.data;
  const detail = data?.detail && typeof data.detail === 'object' ? data.detail : data;
  return detail && typeof detail === 'object' ? detail : {};
}

export function isInsufficientTokensResponse(response) {
  if (response?.status !== 402) {
    return false;
  }
  const detail = tokenErrorDetail(response);
  return detail.code === 'insufficient_tokens' || detail.code === 'token_hard_limit_reached';
}

export function normalizeInsufficientTokensDetail(response, config = {}) {
  const detail = tokenErrorDetail(response);
  return {
    code: detail.code || 'insufficient_tokens',
    operationKey: detail.operation_key || detail.operationKey || null,
    message: detail.message || 'Insufficient token balance.',
    balance: detail.balance ?? detail.current_balance ?? detail.currentBalance ?? null,
    requiredTokens: detail.required_tokens ?? detail.requiredTokens ?? detail.required ?? null,
    route: config?.url || null,
    raw: detail,
  };
}

export function notifyInsufficientTokens(response, config = {}) {
  if (typeof window === 'undefined' || !isInsufficientTokensResponse(response)) {
    return;
  }
  window.dispatchEvent(
    new CustomEvent('tokens:insufficient', {
      detail: normalizeInsufficientTokensDetail(response, config),
    })
  );
}
